import { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'

function TicketInfo({ handleClose, isLargeScreen }) {
  return (
    <>
      <div className="UserChatView ">
        <ul class="nav nav-tabs nav-tab lined d-none d-lg-flex " role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-bs-toggle="tab"
              href="#example1a"
              role="tab"
            >
              <ion-icon name="information-circle-outline"></ion-icon>
              Infomation
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-bs-toggle="tab"
              href="#example2a"
              role="tab"
            >
              <ion-icon name="hourglass-outline"></ion-icon>
              TimeLine
            </a>
          </li>
        </ul>
        <div class="tab-content ">
          {/* Tap-1 */}
          <div class="tab-pane active" id="example1a" role="tabpanel">
            <ul class="listview simple-listview bg-light ticket-info border-0 m-2">
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Status:</h4>
                <Form.Select aria-label="Default select example">
                  <option>Open</option>
                  <option value="1">Pending</option>
                  <option value="2">resolve</option>
                  <option value="3">Closed</option>
                </Form.Select>
                {/* <a href="">
                  <p className="mb-0 ms-2">Pending on SI</p>
                </a> */}
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">Priority:</h4>
                <Form.Select aria-label="Default select example">
                  <option>Open</option>
                  <option value="1">Pending</option>
                  <option value="2">resolve</option>
                  <option value="3">Closed</option>
                </Form.Select>
                {/* <a href="">
                  <p className="mb-0 ms-2">Priority 1</p>
                </a> */}
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">Organization:</h4>
                <Form.Select aria-label="Default select example">
                  <option>Open</option>
                  <option value="1">Pending</option>
                  <option value="2">resolve</option>
                  <option value="3">Closed</option>
                </Form.Select>
                {/* <a href="">
                  <p className="mb-0 ms-2">
                    Fleetguard Filters Private Limited
                  </p>
                </a> */}
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">Department:</h4>
                <Form.Select aria-label="Default select example">
                  <option>Open</option>
                  <option value="1">Pending</option>
                  <option value="2">resolve</option>
                  <option value="3">Closed</option>
                </Form.Select>
                {/* <a href="">
                  <p className="mb-0 ms-2">General Oracle Support</p>
                </a> */}
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">User:</h4>
                <a href="">
                  <p className="mb-0 ms-2">Vishal Fleetguard</p>
                </a>
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">Email:</h4>
                <a href="">
                  <p className="mb-0 ms-2">vishal@dmvsca.com</p>
                </a>
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">Source:</h4>
                <a href="">
                  <p className="mb-0 ms-2">Web/IP:(2.50.182.82)</p>
                </a>
              </li>
              <li className="justify-content-start">
                <h4 className="mb-0 fw-bold">Create Date:</h4>
                <a href="">
                  <p className="mb-0 ms-2">08/11/2024 10:57 pm</p>
                </a>
              </li>
            </ul>
            <hr />
            <ul class="listview simple-listview bg-light ticket-info border-0 m-2 ">
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Assigned To:</h4>
                <a href="">
                  <p className="mb-0 ms-2">Rutik Patil</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Help Topic:</h4>
                <a href="">
                  <p className="mb-0 ms-2">General Oracle Support</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">SLA Plan:</h4>
                <a href="">
                  <p className="mb-0 ms-2">-None-</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Last Message:</h4>
                <a href="">
                  <p className="mb-0 ms-2">08/11/2024 10:57 pm</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Due Date:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Last Response:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
            </ul>
            <hr />
            <ul class="listview simple-listview bg-light ticket-info border-0 m-2 ">
              <li
                className="justify-content-start"
                style={{ borderBottom: '1px solid #e1e1e1' }}
              >
                <h2 className="mb-0 fw-bold">Ticket Details</h2>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Ticket Type:</h4>
                <a href="">
                  <p className="mb-0 ms-2">Service Request</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Functional Area:</h4>
                <a href="">
                  <p className="mb-0 ms-2">Financials</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Instance:</h4>
                <a href="">
                  <p className="mb-0 ms-2">Production</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Number of Users impacted:</h4>
                <a href="">
                  <p className="mb-0 ms-2">3</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Expected Due Date:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Requested By:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Reference Ticket ID:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Close Reason:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
              <li className="justify-content-start ">
                <h4 className="mb-0 fw-bold">Close Description:</h4>
                <a href="">
                  <p className="mb-0 ms-2">—Empty—</p>
                </a>
              </li>
            </ul>
          </div>

          {/* Tap-2 */}
          <div class="tab-pane fade mx-2" id="example2a" role="tabpanel">
            <div class="timeline timed">
              {/* <button onClick={handleClose}>close</button> */}
              <div
                class="item "
                onClick={() => {
                  document
                    .querySelector('#c_1')
                    ?.scrollIntoView({ behavior: 'smooth' })
                  {
                    !isLargeScreen ? handleClose() : handleClose()
                  }
                }}
              >
                <span class="time pe-1">05/01/2024 5:35 pm</span>
                <div class="text text-dot">
                  <img
                    src="assets/img/icon/created.png"
                    className="imaged rounded-0"
                    alt="avatar"
                    style={{
                      width: '20px',
                      filter:
                        'invert(35%) sepia(94%) saturate(12%) hue-rotate(347deg) brightness(94%) contrast(90%)'
                    }}
                  />
                </div>
                {/* <div class="dot"></div> */}
                <div class="content">
                  <h4 class="title">
                    Created by &nbsp;
                    <span>
                      <img
                        src="assets/img/sample/avatar/avatar3.jpg"
                        alt="avatar"
                        class="imaged w16 rounded "
                      />
                    </span>
                    &nbsp; Avataru_fin_02
                  </h4>

                  {/* <div class="text">Talk about the project</div> */}
                </div>
              </div>
              <div
                class="item "
                onClick={() => {
                  document
                    .querySelector('#c_2')
                    ?.scrollIntoView({ behavior: 'smooth' })
                  {
                    !isLargeScreen ? handleClose() : handleClose()
                  }
                }}
              >
                <span class="time pe-1">05/01/2024 5:35 pm</span>
                <div class="text text-dot">
                  <img
                    src="assets/img/icon/Collaborators.png"
                    className="imaged w24 rounded-0"
                    alt="avatar"
                    style={{
                      filter:
                        'invert(35%) sepia(94%) saturate(12%) hue-rotate(347deg) brightness(94%) contrast(90%)'
                    }}
                  />
                </div>
                {/* <div class="dot bg-danger"></div> */}
                <div class="content">
                  <h4 class="title">
                    SYSTEM added &nbsp;
                    <span>
                      <img
                        src="assets/img/sample/avatar/avatar3.jpg"
                        alt="avatar"
                        class="imaged w16 rounded "
                      />
                    </span>
                    &nbsp; u_super_01 as collaborators
                  </h4>
                  {/* <div class="text">
                  <img
                    src="assets/img/sample/avatar/avatar3.jpg"
                    alt="avatar"
                    class="imaged w24 rounded"
                  />
                  <img
                    src="assets/img/sample/avatar/avatar4.jpg"
                    alt="avatar"
                    class="imaged w24 rounded"
                  />
                  <img
                    src="assets/img/sample/avatar/avatar5.jpg"
                    alt="avatar"
                    class="imaged w24 rounded"
                  />
                  <img
                    src="assets/img/sample/avatar/avatar7.jpg"
                    alt="avatar"
                    class="imaged w24 rounded"
                  />
                </div> */}
                </div>
              </div>
              <div
                class="item"
                onClick={() => {
                  document
                    .querySelector('#c_3')
                    ?.scrollIntoView({ behavior: 'smooth' })
                  {
                    !isLargeScreen ? handleClose() : handleClose()
                  }
                }}
              >
                <span class="time pe-1">04/17/2024 1:28 pm</span>
                <div class="text text-dot">
                  <img
                    src="assets/img/icon/assigned.png"
                    className="imaged w24 rounded-0"
                    alt="avatar"
                    style={{
                      filter:
                        'invert(35%) sepia(94%) saturate(12%) hue-rotate(347deg) brightness(94%) contrast(90%)'
                    }}
                  />
                </div>
                {/* <div class="dot bg-warning"></div> */}
                <div class="content">
                  <h4 class="title">
                    Ticket Filter assigned this to{' '}
                    <span className="text-muted">
                      Primary Assignees - Unacademy
                    </span>
                  </h4>
                  {/* <div class="text">
                  Get a ticket for party at tonight 9:00 PM
                </div> */}
                </div>
              </div>
              <div
                class="item"
                onClick={() => {
                  document
                    .querySelector('#c_4')
                    ?.scrollIntoView({ behavior: 'smooth' })
                  {
                    !isLargeScreen ? handleClose() : handleClose()
                  }
                }}
              >
                <span class="time pe-1">05/01/2024 5:36 pm</span>
                <div class="text text-dot">
                  <img
                    src="assets/img/icon/transfer.png"
                    alt="avatar"
                    class="imaged w24 rounded-0 "
                    style={{
                      filter:
                        'invert(35%) sepia(94%) saturate(12%) hue-rotate(347deg) brightness(94%) contrast(90%)'
                    }}
                  />
                </div>
                {/* <div class="dot bg-info"></div> */}
                <div class="content">
                  <h4 class="title">
                    &nbsp;
                    <span>
                      <img
                        src="assets/img/sample/avatar/avatar3.jpg"
                        alt="avatar"
                        class="imaged w16 rounded "
                      />
                    </span>
                    &nbsp; Anay Jain transferred this &nbsp;
                    <span>
                      <img
                        src="assets/img/sample/avatar/avatar3.jpg"
                        alt="avatar"
                        class="imaged w16 rounded "
                      />
                    </span>
                    AirAsia-EPM
                  </h4>
                  {/* <div class="text">Export the version 2.3</div> */}
                </div>
              </div>
              <div
                class="item"
                onClick={() => {
                  document
                    .querySelector('#c_5')
                    ?.scrollIntoView({ behavior: 'smooth' })
                  {
                    !isLargeScreen ? handleClose() : handleClose()
                  }
                }}
              >
                <span class="time pe-1">04/17/2024 1:29 pm</span>
                <div class="text text-dot">
                  <img
                    src="assets/img/icon/update.png"
                    alt="avatar"
                    class="imaged w24 rounded-0 "
                    style={{
                      filter:
                        'invert(35%) sepia(94%) saturate(12%) hue-rotate(347deg) brightness(94%) contrast(90%)'
                    }}
                  />
                </div>
                {/* <div class="dot bg-info"></div> */}
                <div class="content">
                  <h4 class="title">
                    Updated by &nbsp;
                    <span>
                      <img
                        src="assets/img/sample/avatar/avatar3.jpg"
                        alt="avatar"
                        class="imaged w16 rounded "
                      />
                    </span>
                    &nbsp; Anay Jain
                  </h4>
                  {/* <div class="text">Export the version 2.3</div> */}
                </div>
              </div>
              <div
                class="item"
                onClick={() => {
                  document
                    .querySelector('#c_6')
                    ?.scrollIntoView({ behavior: 'smooth' })
                  {
                    !isLargeScreen ? handleClose() : handleClose()
                  }
                }}
              >
                <span class="time pe-1">05/01/2024 5:36 pm</span>
                <div class="text text-dot">
                  <img
                    src="assets/img/icon/claim.png"
                    alt="avatar"
                    class="imaged w24 rounded-0 "
                    style={{
                      filter:
                        'invert(35%) sepia(94%) saturate(12%) hue-rotate(347deg) brightness(94%) contrast(90%)'
                    }}
                  />
                </div>
                {/* <div class="dot bg-info"></div> */}
                <div class="content">
                  <h4 class="title">
                    &nbsp;
                    <span>
                      <img
                        src="assets/img/sample/avatar/avatar3.jpg"
                        alt="avatar"
                        class="imaged w16 rounded "
                      />
                    </span>
                    &nbsp; Anay Jain claimed this
                  </h4>
                  {/* <div class="text">Export the version 2.3</div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TicketInfo
